module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAM1BMVEUAAAAyMjIyMjIwMDAyMjIyMjIyMjIyMjIzMzMzMzM0NDQyMjIzMzMzMzMwMDAyMjIzMzO4E+iTAAAAEHRSTlMA3+8gn4Awz69QQGBfvxBwh6W1VgAAAJhJREFUOMvtkksKAzEMQyPH+c6nuv9puyglScGmMItSmLeKQBbEcrj5F7qCLNqCTzwomlIFET1fFtlfrw2SnTwZORFiZwJxnjosX+M+y43dMCpWLWoYS3UHB0yrTrxqhK66Fusz4g4O+ud6zMKPuYwIXK8wZMH7KITZPTMQNSUVFj6CS9NCQnuoI9LnBM7vnH1qyqflcPMznuVeA3sjImHLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.png
// module id = p1AH
// module chunks = 12